var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "625.667px",
    height: "557.582px",
    viewBox: "0 0 625.667 557.582",
    enableBackground: "new 0 0 625.667 557.582",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFC24D",
    cx: 450,
    cy: 352.332,
    r: 74.667
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3699FF",
    cx: 466,
    cy: 525.332,
    r: 19.167
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A71FF",
    d: "M12.613,0c15.349,31.034,64.239,112.614,159.929,127.667c28.984,4.559,59.535,4.631,88.54,0.715 c21.685-2.928,42.576-9.201,64.094-12.799c13.967-2.336,28.159-3.492,42.318-3.55c19.51-0.08,39.068,1.979,58.052,6.526 c25.992,6.226,49.502,17.692,72.163,31.636c6.225,3.829,12.369,7.79,18.522,11.73c20.148,12.903,40.046,25.969,58.678,41.017 c14.209,11.476,28.02,23.134,41.924,34.976c1.059,0.901,8.834,6.172,8.834,7.75V0H12.613z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fill: "#48D89E",
    d: "M625.667,104.667c-89.858,25-163.932,109.37-163.932,216.332 c0,106.964,71.805,194.956,163.932,205.891V257.668V104.667z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop);
export default __webpack_public_path__ + "static/media/top.7f7848f4a8597cc7d61431dada2b5cce.svg";
export { ForwardRef as ReactComponent };